<div class="label-section">
  <label [for]="forId">
    {{ label }}
  </label>
  @if (showOptionalText && !hideOptionalText) {
    <span>Frivillig</span>
  }
  @if (showIsRequiredError) {
    <span class="error-text required-text">*Påkrevd</span>
  }
  @if (labelHelpText) {
    <span class="label-help-text" [ngClass]="{ 'error-text': isErrorState }">
      {{ labelHelpText }}
    </span>
  }
</div>

<div class="select-wrapper">
  <button
    class="select-button"
    type="button"
    [attr.data-testid]="buttonTestId()"
    [disabled]="isDisabled"
    [ngClass]="{ isOpen: isOptionListVisible, 'has-error': isErrorState }"
    (blur)="closeDropdown()"
    (click)="toggleDropdown()"
    (keydown)="handleArrowNavigation($event)"
  >
    <span class="selected-value">{{ selectedDisplayName ?? placeholder }}</span>
    @if (!!icon) {
      <mat-icon class="dropdown-icon" [svgIcon]="icon" />
    }
  </button>
  <ul
    #optionsList
    class="select-options-list"
    [ngClass]="{ 'dropdown-visible': isOptionListVisible }"
    [ngStyle]="{ 'max-height': optionListHeight }"
  >
    @for (option of options | sortBy: 'displayName'; track option.value) {
      <li
        class="select-option"
        [ngClass]="{ isSelected: selectedValue === option.value }"
        (click)="selectOption(option.value)"
        (mouseout)="cancelBlur = false"
        (mouseover)="cancelBlur = true"
      >
        <input type="radio" [attr.data-testid]="textTestId()" [id]="forId" [value]="option.value" />
        @if (getDoubleLineText(option); as text) {
          <label class="double-line-label" [for]="forId">
            <div class="title-row">
              <span>{{ text.topLeftText }}</span>
              <span>{{ text.topRightText }}</span>
            </div>
            @if (!!text.bottomLeftText || !!text.bottomRightText) {
              <div class="description-row">
                <span>{{ text.bottomLeftText }}</span>
                <span>{{ text.bottomRightText }}</span>
              </div>
            }
          </label>
        } @else {
          <label [for]="forId">{{ option.displayName }}</label>
        }
      </li>
    }
  </ul>
</div>

@if (isErrorState && !!errorText && !showIsRequiredError) {
  <div class="error-section">
    <mat-icon [svgIcon]="IconNames.ice_warning" />
    <span>{{ errorText }}</span>
  </div>
} @else if (!!longHelpText) {
  <div class="long-help-text">{{ longHelpText }}</div>
}
